import React from "react";
import { connect } from "react-redux";
import { setDevConfig } from "../actions";
import { DatePickerPadrao, LabelPadrao, ModalPadrao } from "./Base";
import { BtnSair } from "./Buttons";

function ModalDevConfig({ visible, onClose, ...props }) {

  return <ModalPadrao title="Configurações desenvolvimento" visible={visible} onCancel={onClose} footer={<BtnSair onClick={onClose} />} width={400} >
    <div style={{ minHeight: 200 }}>
      <LabelPadrao noMargin>Data servidor</LabelPadrao>
      <DatePickerPadrao value={props.devConfig.find(x => x.nome == "dataSistemaDev")?.valor} onChange={v => props.setDevConfig("dataSistemaDev", v, v?.format('DD/MM/YYYY'))} allowClear />
    </div>

  </ModalPadrao>;
}

const mapStateToProps = state => ({ devConfig: state.devConfig });

export default connect(mapStateToProps, { setDevConfig })(ModalDevConfig);